/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import CursoList from './CursoList';
import {bindActionCreators} from 'redux';
import * as cursoActions from '../../actions/cursoActions';
import toastr from 'toastr';
import ManageList from '../common/ManageList';
import { Segment} from 'semantic-ui-react';
import ModalSiNo from '../common/ModalSiNo';
import $ from 'jquery';
import {getMargenes} from '../../util/'; 
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';

import {usuarioActual, validaApiToken} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';




class ManageCursoList extends ManageList  {
    constructor(props, context) {
		
		super(props, context);
        this.state={
            errors:{},
            strings:[],
            showActivos:true,
            filtrosCombo:{},
            permisos:{},
            showModalDuplicar:false
		};
	}

	componentDidMount(){
        //this.props.history.push(this.props.location)
        usuarioActual(this, "Curso",true).then( (usuario)=>{
           window.scrollTo(0, 0);
           this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
		   if(this.props.user!=null)
		      this.inicializa();
       })
        .catch(error=>{
          toastr.error(error);
        }); 
    
	}
    
    
    onShowModalDuplicar=(idDuplicar, event)=>{
        this.setState({"idDuplicar": idDuplicar});
		this.setState({"showModalDuplicar": true}); 
	}
    
    
    duplicar=()=>{
        
		this.oncloseModal();

        validaApiToken(this).then( (userToken)=>{    
            this.props.listadoActions.setDuplicar(this.state.idDuplicar, userToken).then( ()=>{
                    this.oncloseModal();
                    this.setState({"idDuplicar": 0});
                    this.inicializa();
            }).catch(error=>{
                  toastr.error(error);
            });     
        })
            
	}
    
    goBack=()=>{
         this.props.history.goBack();
    }
  
    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 
		return (
            <Segment  style={margenes}>
                  
                <CursoList
                    strings={this.props.strings}
                    curso={this.props.listado.content}
                    activePage={this.props.listado.paginaActual+1}
                    handleSelectPagination={this.handleSelectPagination}
                    totalPages={this.props.listado.totalPages}
                    handleChange= {this.handleChangeFiltro}
                    filtro={this.state.filtro}
                    onFiltrarInformacion={this.onFiltrarInformacion}
                    filtroActivo={this.props.listado.filtroActivo}
                    filtroActual={this.props.listado.filtroActual}
                    onDesactivarFiltro={this.onDesactivarFiltro}
                    confirmarBorrado={this.confirmarBorrado}
                    onShowModalBorrar={this.onShowModalBorrar}
                    onShowModalActivar={this.onShowModalActivar}
                    onShowModalDuplicar={this.onShowModalDuplicar}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    handleChangeFiltro= {this.handleChangeFiltro}
                    handleChangeActivos={this.handleChangeActivos}
                    showActivos={this.props.listado.showActivos}
                    color={this.props.color}
				    form={this.props.form}
                    permisos={this.state.permisos}
                    goBack={this.goBack}
                />
            
                <ModalSiNo
                    showModal={this.state.showModalBorrar}
                    closeModal={this.oncloseModal}
                    borrar={this.borrar}
                    icono={"trash"}
                    texto={"Esta seguro que desea eliminar este registro de forma permanente?"}
                    titulo={this.state.strings?this.state.strings["Curso"]:""}
                />
            
                <ModalSiNo
                    showModal={this.state.showModalActivar}
                    closeModal={this.oncloseModal}
                    borrar={this.activar}
                    icono={"exchange"}
                    texto={"Esta seguro que desea cambiar el esatus del registro?"}
                    titulo={this.state.strings?this.state.strings["Curso"]:""}
                 />
            
                <ModalSiNo
                    showModal={this.state.showModalDuplicar}
                    closeModal={this.oncloseModal}
                    borrar={this.duplicar}
                    icono={"exchange"}
                    texto={"Esta seguro que desea duplicar este curso, esto realizará una copia de todo su contenido?"}
                    titulo={this.state.strings?this.state.strings["Curso"]:""}
                 />    

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    return {
        listado:state.curso,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        permisos:state.permisos,
        strings:state.strings, 
        form:state.form,
        user:state.user, 
        idioma:state.idioma,
    }

}

function mapDispatchToProps(dispatch){

	return {   
        menuActions:bindActionCreators(menuActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        listadoActions: bindActionCreators(cursoActions, dispatch),
        load:bindActionCreators(cursoActions.getCursoList, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageCursoList);